import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  // 默认使用浅色科技风（可在右上角切换）
  navTheme: 'light',
  // 主色：#6366F1
  colorPrimary: '#6366F1',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: 'Ant Design Pro',
  pwa: true,
  logo: 'https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg',
  iconfontUrl: '',
  token: {
    colorPrimary: '#6366F1',
    colorPrimaryHover: '#4F46E5',
    colorPrimaryActive: '#4338CA',
    colorBgLayout: '#F5F7FA',
    colorBgContainer: '#FFFFFF',
    colorBgElevated: '#FFFFFF',
    colorBorder: '#E5E7EB',
    colorBorderSecondary: '#F1F5F9',
    colorText: '#111827',
    colorTextSecondary: '#4B5563',
    colorTextTertiary: '#9CA3AF',
    colorTextQuaternary: '#D1D5DB',
    borderRadius: 12,
    boxShadowSecondary: '0 1px 2px rgba(0,0,0,0.05)',
    boxShadow: '0 10px 20px rgba(0,0,0,0.12)',
  },
};

export default Settings;
